import { createFileRoute } from "@tanstack/react-router"
import { SearchValue } from "../../-components/infinit-scrolling-table/extended-infinit-scrolling-table"
import { LoggingTablePage } from "./-components/LoggingTablePage"

export const Route = createFileRoute("/app/admin-settings/logging/")({
  component: LoggingTablePage,
  validateSearch: (search: SearchValue<"/api/Log/GetPaginatedLogData">) =>
    search,
  beforeLoad: (ctx) => ({ getTitle: () => ctx.context.t("NavItem_Logging") }),
})
